module.exports = "data:image/webp;base64,UklGRsQAAABXRUJQVlA4WAoAAAAQAAAARwAASAAAQUxQSGoAAAABT0AQQBpcoAQmmOOIiCCrXrCJbSsOa48cBDBYYHCBjRhI5gnOdqmgiui/ArdtlDEdwyPMZsJmAByK5j9e6oTWYQGtjGi/Tlq1fMOn63fqO7o7J80GxmFKXjuaeXbLoxzyxzJ/NfPnbzs0VlA4IDQAAAAQBACdASpIAEkAPpFIoUylpCMiIUgAsBIJaQAACfGjRo0aNGjRo0Z+AAD++M7xSAAAAAAA"


//////////////////
// WEBPACK FOOTER
// ./src/components/head_nav/images/back_block.webp
// module id = v50v
// module chunks = 12